import {
	BuildingOffice2Icon,
	ChevronDownIcon,
	Cog8ToothIcon,
	ExclamationTriangleIcon,
	MinusIcon,
} from "@heroicons/react/20/solid";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as QUICKBOOKS_ACTIONS } from "./store/quickbooksActions";
import Select from "react-select";

import Logo from "./assets/quickbooks-icon.svg";
import { getCurrency } from "../../common/validation/Validators";
import QuickbooksSearchContact from "./QuickbooksEmployeeLink";
import { CustomOption } from "@/components/common/custom-selectors/CustomOption";
import { groupBy } from "lodash";
import { useMemo } from "react";
const unfinished = false;
// const unfinished = true

const paymentOptions = [
	{ label: "Bills", value: "Bills" },
	{ label: "Journals", value: "Journals" },
];

const QuickbooksSettings = ({
	connected,
	needsVerification,
	connect,
	disconnect,
	disabled,
	taxNames,
	saving,
	companyName,
	save,
	overtimes,
	allowances,
	getExpenseOptions,
	expenseSettings,
	hasCurrency,
	loading,
	expenses,
	jurisdiction,
}) => {
	const [expand, setExpand] = useState(false);
	const [quickbooksSettings, setQuickbooksSettings] = useState();
	const updateSetting = ({ category, field, value }) => {
		if (!category) {
			setQuickbooksSettings({
				...quickbooksSettings,
				[field]: value,
			});
		} else {
			setQuickbooksSettings({
				...quickbooksSettings,
				[category]: {
					...quickbooksSettings?.[category],
					[field]: value,
				},
			});
		}
	};

	const isJournals = quickbooksSettings?.paymentType === "Journals";

	const [expenseOptions, expenseSelectable] = useMemo(() => {
		const expenseSelectable = Object.entries(groupBy(expenses, "category"))
			.map(([key, value]) => ({
				label: key,
				options: value?.map((e) => ({ label: e.name, value: e.id, ...e })) || [],
			}))
			?.filter((e) => (quickbooksSettings?.paymentType === "Bills" ? e.label === "Expense" : true));

		const expenseOptions = expenseSelectable.flatMap((e) => e.options);

		return [expenseOptions, expenseSelectable];
	}, [JSON.stringify(expenses), quickbooksSettings?.paymentType]);

	useEffect(() => {
		if (!expand || !connected) return;
		getExpenseOptions();
	}, [expand]);

	useEffect(() => {
		setQuickbooksSettings({
			...expenseSettings,
			paymentType: expenseSettings?.paymentType || paymentOptions[0].value,
		});
	}, [JSON.stringify(expenseSettings)]);

	return (
		<div className={`${expand ? "tr-gray" : ""} col-xs-12 integration-row`}>
			<div className="col-sm-3">
				<img
					src={Logo}
					width="40px"
				/>
				<span style={{ paddingLeft: 20, fontSize: 16 }}>QuickBooks</span>
			</div>
			<div className="col-sm-9">
				{unfinished ? (
					<div className="btn btn-default pull-right">Coming Soon</div>
				) : (
					<>
						<button
							className={`btn btn-${connected ? "default" : "primary"} pull-right`}
							style={{ marginTop: 2 }}
							onClick={() => {
								if (connected) setExpand(!expand);
								else connect();
							}}
						>
							{connected ? (
								<>
									<Cog8ToothIcon style={{ height: "1.5em", float: "left" }} />
									<div style={{ float: "left", marginLeft: 5 }}>Settings</div>
									<ChevronDownIcon
										style={{
											height: "1.5em",
											float: "left",
											transform: expand ? "rotate(180deg)" : "rotate(0deg)",
											transition: "transform 0.2s ease-in-out",
										}}
									/>
								</>
							) : (
								"Connect"
							)}
						</button>
						{connected && (
							<button
								className={`btn ${needsVerification ? "btn-primary" : "btn-default"} pull-right`}
								style={{ marginTop: 2, marginRight: 10 }}
							>
								{loading ? "Loading..." : "Connected"}
							</button>
						)}
					</>
				)}
			</div>
			<div className="clearfix" />
			{expand && connected ? (
				<>
					<div
						className="col-xs-12"
						style={{ marginTop: "15px" }}
					>
						<button
							className="btn btn-primary pull-right"
							onClick={() => disconnect()}
						>
							<MinusIcon style={{ height: "1.5em", float: "left" }} />
							<div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
						</button>
					</div>
					<div
						className="row"
						style={{ paddingBottom: 0, paddingTop: "1rem" }}
					>
						{!hasCurrency && !loading ? (
							<>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										placeContent: "center",
										padding: "3rem",
									}}
								>
									<div
										className="item item-circle bg-danger"
										style={{ position: "relative", height: "8rem", width: "8rem" }}
									>
										<ExclamationTriangleIcon
											style={{
												position: "absolute",
												height: "6rem",
												color: "white",
												right: "1rem",
												top: "1rem",
											}}
										/>
									</div>
								</div>
								<div
									className="col-xs-12"
									style={{ textAlign: "center" }}
								>
									<h4>
										{companyName} does not support{" "}
										<span style={{ color: "#ea611c", fontWeight: "bolder" }}>
											{getCurrency(jurisdiction)}
										</span>{" "}
										transactions
									</h4>
								</div>
							</>
						) : null}
						{!loading && hasCurrency && (
							<>
								<div className="col-xs-6">
									<label>Organisation</label>
									<Select
										isDisabled={true}
										classNamePrefix="react-select-search"
										placeholder={
											<div
												style={{
													display: "flex",
													justifyContent: "space-between",
													alignItems: "center",
												}}
											>
												<div>{companyName}</div>
												<BuildingOffice2Icon
													style={{ height: "2rem", display: "block", paddingRight: "2rem" }}
												/>
											</div>
										}
									/>
								</div>
								<div className="col-xs-6">
									<label>Save As</label>
									<Select
										isDisabled={disabled}
										options={paymentOptions}
										value={paymentOptions.find((e) => e.value === quickbooksSettings?.paymentType)}
										onChange={(selected) =>
											updateSetting({ field: "paymentType", value: selected?.value })
										}
									/>
								</div>
								<div className="clearfix" />
								<div className="row">
									<h5>{isJournals ? "Net" : "Basic"} Salaries</h5>

									<div
										className="col-xs-6"
										style={{ marginTop: "15px" }}
									>
										{isJournals ? (
											<>
												<label>To</label>
											</>
										) : null}
										<Select
											isDisabled={disabled}
											value={expenseOptions?.find(
												(e) => e.value == quickbooksSettings?.basic?.credit,
											)}
											options={expenseSelectable}
											components={{ Option: CustomOption }}
											isClearable
											onChange={(selected) =>
												updateSetting({
													category: "basic",
													field: "credit",
													value: selected?.value,
												})
											}
										/>
									</div>
									{isJournals ? (
										<>
											<div
												className="col-xs-6"
												style={{ marginTop: "15px" }}
											>
												<label>From</label>

												<Select
													isDisabled={disabled}
													value={expenseOptions?.find(
														(e) => e.value == quickbooksSettings?.basic?.debit,
													)}
													options={expenseSelectable}
													components={{ Option: CustomOption }}
													onChange={(selected) =>
														updateSetting({
															category: "basic",
															field: "debit",
															value: selected?.value,
														})
													}
												/>
											</div>
										</>
									) : null}
								</div>
								{!isJournals && [...overtimes, ...allowances]?.length > 0 ? (
									<>
										<div className="row">
											<h5>Allowances & Overtime</h5>

											{[...overtimes, ...allowances]?.map((allowance) => (
												<>
													<div
														className="col-xs-6"
														style={{ marginTop: "15px" }}
														key={allowance.id}
													>
														<label>
															{allowance.name} {isJournals ? " - Credit" : null}
														</label>

														<Select
															isDisabled={disabled}
															value={expenseOptions?.find(
																(e) =>
																	e.value ==
																	quickbooksSettings?.[allowance.id]?.credit,
															)}
															isClearable
															options={expenseSelectable}
															components={{ Option: CustomOption }}
															onChange={(selected) =>
																updateSetting({
																	category: allowance.id,
																	field: "credit",
																	value: selected?.value,
																})
															}
														/>
													</div>
													{isJournals ? (
														<>
															<div
																className="col-xs-6"
																style={{ marginTop: "15px" }}
															>
																<label>{allowance.name}</label>

																<Select
																	isDisabled={disabled}
																	value={expenseOptions?.find(
																		(e) =>
																			e.value ==
																			quickbooksSettings?.[allowance.id]?.debit,
																	)}
																	isClearable
																	options={expenseSelectable}
																	components={{ Option: CustomOption }}
																	onChange={(selected) =>
																		updateSetting({
																			category: allowance.id,
																			field: "debit",
																			value: selected?.value,
																		})
																	}
																/>
															</div>
														</>
													) : null}
												</>
											))}
										</div>
									</>
								) : null}

								{/* {isJournals && departments?.length > 0 ? <>
                <div className="row">
                  <h5>Departments</h5>


                  {departments?.map((department) => (
                    <>
                      <div className="col-xs-6" style={{ marginTop: "15px" }} key={department.id}>
                        <label>{department.name} {isJournals ? ' - Credit' : null}</label>

                        <Select
                          isDisabled={disabled}
                          value={expenseOptions?.find(e => e.value == quickbooksSettings?.[department.id]?.credit)}

                          options={expenseSelectable}
                          onChange={(selected) => updateSetting({ category: department.id, field: 'credit', value: selected?.value })}
                        />

                      </div>
                      <div className="col-xs-6" style={{ marginTop: "15px" }}>
                        <label>{department.name} - Debit</label>

                        <Select
                          isDisabled={disabled}
                          value={expenseOptions?.find(e => e.value == quickbooksSettings?.[department.id]?.debit)}
                          options={expenseSelectable}
                          onChange={(selected) => updateSetting({ category: department.id, field: 'debit', value: selected?.value })}
                        />

                      </div>
                    </>
                  ))}
                </div>
              </> : null} */}

								<div className="row">
									<h5>Taxes</h5>

									{taxNames?.map((taxName) => (
										<>
											<div
												className="col-xs-6"
												style={{ marginTop: "15px" }}
												key={taxName}
											>
												<label>
													{taxName} {isJournals ? "To" : null}
												</label>

												<Select
													isDisabled={disabled}
													value={expenseOptions?.find(
														(e) => e.value == quickbooksSettings?.[taxName]?.credit,
													)}
													options={expenseSelectable}
													components={{ Option: CustomOption }}
													isClearable
													onChange={(selected) =>
														updateSetting({
															category: taxName,
															field: "credit",
															value: selected?.value,
														})
													}
												/>
											</div>
											{isJournals ? (
												<>
													<div
														className="col-xs-6"
														style={{ marginTop: "15px" }}
													>
														<label>{taxName} From</label>
														<Select
															isDisabled={disabled}
															components={{ Option: CustomOption }}
															value={expenseOptions?.find(
																(e) => e.value == quickbooksSettings?.[taxName]?.debit,
															)}
															options={expenseSelectable}
															onChange={(selected) =>
																updateSetting({
																	category: taxName,
																	field: "debit",
																	value: selected?.value,
																})
															}
														/>
													</div>
												</>
											) : (
												<>
													<div
														className="col-xs-6"
														style={{ marginTop: "15px" }}
													>
														<QuickbooksSearchContact
															label={`${taxName} Payable to`}
															selectedValue={quickbooksSettings?.[taxName]?.payable}
															onChange={(selected) =>
																updateSetting({
																	category: taxName,
																	field: "payable",
																	value: selected,
																})
															}
														/>
													</div>
												</>
											)}
										</>
									))}
								</div>
								<div className="pull-right">
									{!disabled ? (
										<button
											className="btn btn-success"
											onClick={() => {
												if (saving) return;
												save(quickbooksSettings);
											}}
										>
											{saving ? "Saving..." : "Save"}
										</button>
									) : null}
								</div>
							</>
						)}
					</div>
				</>
			) : null}
		</div>
	);
};

const mapStateToProps = (state) => {
	const { quickbooks } = { ...state.integration?.accounting };
	const {
		companyName,
		taxNames,
		saving,
		expenseOptions,
		loading,
		hasCurrency,
		settings: expenseSettings,
	} = { ...quickbooks };

	const { jurisdiction, departments, overtimes, allowances } = state?.company?.settings;

	return {
		hasCurrency,
		connected: !!quickbooks,
		disabled: state?.permissions?.my?.permissions?.settings == "Read",
		saving,
		companyName,
		expenses: expenseOptions,
		jurisdiction,
		departments: Array.isArray(departments) ? [{ name: "No Department", id: "No Department" }, ...departments] : [],
		overtimes: Array.isArray(overtimes) ? overtimes : [],
		allowances: Array.isArray(allowances) ? allowances : [],
		taxNames,
		loading,
		expenseSettings,
	};
};

const mapDispatchToProps = (dispatch) => ({
	connect: () => dispatch(QUICKBOOKS_ACTIONS.connectQuickbooks()),
	disconnect: () => dispatch(QUICKBOOKS_ACTIONS.disconnectQuickbooks()),
	getExpenseOptions: () => dispatch(QUICKBOOKS_ACTIONS.getExpenseOptions()),
	save: (data) => dispatch(QUICKBOOKS_ACTIONS.updateQuickBooksDetails(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QuickbooksSettings);
